import http from "@/apps/shared/baseService/config";

class Service {
  list(payload) {
    return http.post(
      "/admin/transaction/list-transactions-stablishment",
      payload
    );
  }
}

export default new Service();
